
export default {
    name: 'FormInput',
    props: {
        // v-model 绑定的值
        value: {
            type: [String, Number],
            default: ''
        },
        // 最大长度限制
        maxLength: {
            type: [String, Number],
            default: 100
        },
        // 输入框类型
        inputType: {
            type: String,
            default: 'text'
        },
        // 占位符文本
        placeholder: {
            type: String,
            default: ''
        },
        // 是否显示字数统计
        showWordLimit: {
            type: Boolean,
            default: false
        },
        // 是否可清空
        clearable: {
            type: Boolean,
            default: true
        },
        // 自适应内容高度（textarea）
        autosize: {
            type: [Boolean, Object],
            default: false
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            inputValue: null
        }
    },
    watch: {
        value: {
            handler(newVal) {
                console.log(newVal, 'newVal', this.inputValue)
                if (newVal !== this.inputValue) {
                    this.inputValue = newVal
                }
            },
            immediate: true
        }
    },
    methods: {
        // 处理输入事件
        handleInput(value) {
            // 如果是数字类型且只允许整数，过滤小数点
            if (this.inputType === 'digit') {
                // 移除除了数字外的部分
                const digitValue = value.replace(/\D/g, '')
                this.inputValue = digitValue !== '' ? Number(digitValue) : digitValue
            } else if (this.inputType === 'number') {
                // 允许小数，只保留数字和一个小数点
                this.inputValue = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace(/^\./, '0.').replace(/(\.\d*)\./g, '$1')
            } else {
                this.inputValue = value
            }
            if(this.value !== this.inputValue) {
                this.$emit('input', this.inputValue)
            }
        },
        // 处理失焦事件
        handleBlur(event) {
            if (this.inputValue !== this.value) {
                const formattedValue = (this.inputType === 'digit' || this.inputType === 'number') && !['', null, undefined].includes(this.inputValue) ? Number(this.inputValue) : this.inputValue
                this.$emit('input', formattedValue)
            }
        }
    }
}
